module.exports = __webpack_public_path__ + "static/media/Transport-van.602737a9.svg";